import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TextStore {

}

export enum TextStoreKeys {

}
